import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  selectedDate: new Date(),
};

export const salarySlice = createSlice({
  name: 'salaryState',
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<Date>) => {
      console.log('action.payload', action.payload);
      state.selectedDate = action.payload;
    },
  },
});

export const { setSelectedDate } = salarySlice.actions;
export default salarySlice.reducer;
